 
 

 const Shimmer =() => {
    return(
<div className="flex flex-wrap m-4 p-4 mx-[60px] my-[60px] justify-between "> 

<div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>

    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>

    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>
    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>
 
    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>

    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>

    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>
    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>
 
 

    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>

    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>

    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>
    <div className="shimmer-container  rounded-lg border w-60 h-60    animate-pulse">
                <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
        <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
        
         
    </div>
 
 





</div>

    )
    
 };

 export default Shimmer;

//  <div className="shimmer-container  rounded-lg border w-60 h-60 mx-16 m-8 p-4 animate-pulse">
//  <div className="  border  rounded-lg mx-[40px] my-2 p-4 w-32 h-32 bg-gray-200"> </div>
// <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>
// <div className=" text-center border mx-[20px] rounded-xl m-4 w-40 h-[14px] bg-gray-200"> </div>
// <div className=" text-center border mx-[20px] rounded-xl w-40 h-[14px] bg-gray-200"> </div>


// </div>